import { css } from 'styled-components';
import { freeLight, tiersLabelGradient } from '@engage/colors';
import { useTiering, useClasses } from '@members/copy';
import { Classes } from '@members/copy/models.generated/Classes';
import { Tiering } from '@members/copy/models.generated/Tiering';
import type { ClassAvailabilityProps } from '../models';
import { CLASS_ACCESS_TYPE } from '../models';
import { useClassAccessType } from './useClassAccessType';

export const useTieringClassLabel = (
  classId: string,
  classAvailabilityProps?: ClassAvailabilityProps,
) => {
  const accessType = useClassAccessType(classId, classAvailabilityProps);
  const exclusiveLabel = useTiering(Tiering.Exclusive);
  const freeLabel = useClasses(Classes.FreeClass);
  const freeForLimitedTimeLabel = useClasses(Classes.FreeLimitedTime);

  switch (accessType) {
    case CLASS_ACCESS_TYPE.EXCLUSIVE:
      return {
        classTierLabel: exclusiveLabel,
        labelStyles: css`
          ${tiersLabelGradient}
          text-transform: capitalize;
        `,
      };
    case CLASS_ACCESS_TYPE.FREE:
      return {
        classTierLabel: freeLabel,
        labelStyles: css`
          color: ${freeLight};
        `,
      };
    case CLASS_ACCESS_TYPE.SAMPLE:
      return {
        classTierLabel: freeForLimitedTimeLabel,
        labelStyles: css`
          color: ${freeLight};
        `,
      };
    default:
      return {
        classTierLabel: '',
        labelStyles: css``,
      };
  }
};
